import medianIncome from '../json/median_income.json';
import expenseBreakdown from '../json/expense_breakdown.json';
import outOfPocketHealth from '../json/out_of_pocket_health.json';
import housingExpenses from '../json/housing_expenses.json';
import regionalTransportation from '../json/regional_transportation_expenses.json';
import adminExpense from '../json/nested_county_district_admin_expense.json';


const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const CACHE_KEY = 'meansTestStandards.active.v1';
let loadPromise = null;

const targets = {
  median_income: medianIncome,
  expense_breakdown: expenseBreakdown,
  out_of_pocket_health: outOfPocketHealth,
  housing_expenses: housingExpenses,
  regional_transportation_expenses: regionalTransportation,
  nested_county_district_admin_expense: adminExpense,
};

function replaceObject(target, replacement) {
  if (!target || !replacement || typeof replacement !== 'object') return;
  Object.keys(target).forEach((key) => delete target[key]);
  Object.assign(target, replacement);
}

function applyStandards(payload) {
  if (!payload?.available || !payload?.data) return false;
  Object.entries(targets).forEach(([key, target]) => {
    replaceObject(target, payload.data[key]);
  });
  return true;
}

function applyCachedStandards() {
  if (typeof window === 'undefined') return;
  try {
    const cached = JSON.parse(window.localStorage.getItem(CACHE_KEY));
    applyStandards(cached);
  } catch {
    window.localStorage.removeItem(CACHE_KEY);
  }
}

applyCachedStandards();

export async function loadMeansTestStandards({ force = false } = {}) {
  if (loadPromise && !force) return loadPromise;

  loadPromise = fetch(`${API_BASE}/means-test-standards/current/`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
    .then(async (response) => {
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload.error || `Could not load means-test standards (${response.status})`);
      }
      if (applyStandards(payload) && typeof window !== 'undefined') {
        try {
          window.localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
        } catch {
          // Calculators still have the in-memory update if browser storage is full.
        }
      }
      return payload;
    })
    .catch((error) => {
      loadPromise = null;
      throw error;
    });

  return loadPromise;
}

export function clearMeansTestStandardsCache() {
  loadPromise = null;
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(CACHE_KEY);
  }
}
